import { Collapse, Grid, IconButton, TableCell, TableRow } from '@mui/material';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import React from 'react';
import { formatNumber } from '../../../../../utils/formatNumber';

const formulaStyle = { color: '#3966f8' };

const PFinRow = ({
  principal,
  base,
  intl,
  bankLoanInterest,
  term,
  expenseForTable,
  totalAmount,
  returnsForTable,
  profitRateWithYearsToShow,
  firstYearBonus,
  cashValueMinusLoan,
  overrideLoanInterest,
  irr,
  yearlyIRR,
  i,
  open,
  onToggleOpen,
  showIRR,
  onSelectRow
}) => {
  const loan = (principal ?? 0) - (base ?? 0) - (firstYearBonus ?? 0);
  const irrValue = irr[i - 1];
  const returnRate = profitRateWithYearsToShow[i];
  const formattedIRR = !isNaN(irrValue) ? irrValue?.toFixed(2) ?? '0' : '-';

  return (
    <>
      <TableRow className="main-rows">
        <TableCell align="center" onClick={onSelectRow}>
          <div>{`${term}`}</div>
        </TableCell>
        <TableCell align="center" style={{ backgroundColor: '#3966f812' }}>
          <div>{formatNumber(base, intl)}</div>
        </TableCell>
        <TableCell align="center">
          <div>{formatNumber(expenseForTable[i], intl)}</div>
        </TableCell>
        <TableCell align="center">
          <div>{formatNumber(totalAmount[i], intl)}</div>
        </TableCell>
        <TableCell align="center" style={{ backgroundColor: '#3ec7f812' }}>
          <div>{formatNumber(cashValueMinusLoan[i], intl)}</div>
        </TableCell>
        <TableCell align="center">
          <Grid container sx={{ alignItems: "center",  justifyContent: "center" }} >
            <Grid size={10}>
              <Grid container sx={{ alignItems: "center",  justifyContent: "center" }}  style={{ marginBottom: '4px' }}>
                <div>{formatNumber(returnsForTable[i], intl)}</div>
                <div className="profit-rate">{`${
                  !isNaN(returnRate) ? returnRate?.toFixed(2) ?? '0' : '-'
                }%`}</div>
              </Grid>
              {open && showIRR && <div>{`*IRR : ${formattedIRR}%`}</div>}
              {open && !showIRR && (
                <div>{`${intl.formatMessage({ id: 'pfa-annual-return' })}: ${
                  !isNaN(yearlyIRR[i]) ? yearlyIRR[i]?.toFixed(2) ?? '0' : '-'
                }%`}</div>
              )}

            </Grid>
            <Grid size={2}>
              <IconButton aria-label="expand row" size="small" onClick={() => onToggleOpen(i)}>
                {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
              </IconButton>
            </Grid>
          </Grid>
        </TableCell>
      </TableRow>
      <TableRow className="collapse-rows">
        <TableCell colSpan={1} align="center" />
        <TableCell colSpan={1} align="center" style={{ backgroundColor: '#3966f812' }} />
        <TableCell colSpan={1} align="center">
          <Collapse in={open}>
            {overrideLoanInterest
              ? intl.formatMessage(
                  { id: 'pfa-table-expense-formula' },
                  { loan: formatNumber(loan, intl) }
                )
              : `${formatNumber(loan, intl)} x ${bankLoanInterest ?? 0}% x ${term}`}
          </Collapse>
        </TableCell>
        <TableCell colSpan={1} align="center" />
        <TableCell colSpan={1} align="center" style={{ backgroundColor: '#3ec7f812' }}>
          <Collapse in={open}>{`${formatNumber(totalAmount[i] ?? 0, intl)} - ${formatNumber(
            loan,
            intl
          )}`}</Collapse>
        </TableCell>
        <TableCell colSpan={1} align="center">
          <Collapse in={open}>
            {!showIRR && (
              <>
                {`${formatNumber(totalAmount[i] ?? 0, intl)} - ${formatNumber(base ?? 0, intl)} - ${formatNumber(
                  loan,
                  intl
                )} - ${intl.formatMessage({ id: 'pfa-total-expense' })}`}{' '}
                <span style={formulaStyle}>{` / ${formatNumber(base, intl)} `}</span>
              </>
            )}
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
};

export default PFinRow;
